import { colors, fontSize, fontWeight, radius, space } from "../../lib/tokens";

interface Props {
  label: string;
  value: number;
  min?: number;
  max?: number;
  step?: number;
  onChange: (next: number) => void;
  error?: string | null;
}

export function NumberField({ label, value, min, max, step = 1, onChange, error }: Props) {
  return (
    <label style={{ display: "block", marginBottom: space.md }}>
      <span style={{ display: "block", fontSize: fontSize.sm, fontWeight: fontWeight.medium, color: colors.stone, marginBottom: 6 }}>
        {label}
      </span>
      <input
        type="number"
        value={value}
        min={min}
        max={max}
        step={step}
        onChange={(e) => {
          const next = Number(e.target.value);
          if (Number.isFinite(next)) onChange(next);
        }}
        style={{
          width: 160, height: 36, padding: "0 12px",
          background: colors.white, border: `1px solid ${error ? colors.error : colors.fog}`,
          borderRadius: radius.sm, fontSize: fontSize.md, color: colors.ink,
          fontFamily: "inherit", outline: "none",
        }}
      />
      {error && (
        <span style={{ display: "block", fontSize: fontSize.sm, color: colors.error, marginTop: 4 }}>{error}</span>
      )}
    </label>
  );
}
